<template>
  <footer
    v-if="isSuccess === status || isFailed === status"
    class="form-fw__footer"
    :class="{ 'form-fw__footer--shadow': shadow }"
  >
    <div class="form-fw__footer__container py-2">
      <div v-if="isSuccess === status" class="text-xs-right">
        <v-btn
          :to="{ name: 'Revenues' }"
          type="submit"
          color="accent"
          depressed
          round
        >
          {{ $t(`${namespace}.backToBilling`) }}
        </v-btn>
      </div>

      <div v-if="isFailed === status" class="text-xs-right">
        <router-link
          v-if="status !== isLoading"
          :to="{ name: 'Revenues' }"
          :title="$t(`${namespace}.backToBilling`)"
          class="accent--text mr-2"
        >{{ $t(`${namespace}.backToBilling`) }}</router-link>

        <v-btn
          type="submit"
          color="accent"
          depressed
          round
          @click="setCurrentStatus"
        >
          {{ $t('Common.tryAgain') }}
        </v-btn>
      </div>
    </div>
  </footer>
</template>

<script>
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'

export default {
  name: 'RevenuesFooter',
  props: {
    kind: {
      type: String
    },
    status: {
      type: Number
    }
  },
  computed: {
    isLoading: () => STATUS_IS_LOADING,
    isSuccess: () => STATUS_SUCCESS,
    isFailed: () => STATUS_FAILED
  },
  data () {
    return {
      namespace: 'Views.RevenuesPage',
      shadow: true
    }
  },
  methods: {
    setChatPosition (bottom = null, right = null) {
      const chat = document.querySelector('#oloswcdl-root .oloswebchat-main .cta-button')
      if (chat) {
        chat.style.bottom = bottom
        chat.style.right = right
      }
    },

    setCurrentStatus () {
      this.$emit('setCurrentStatus', null)
      this.setChatPosition('26px', '43px')
    },

    handleShadow () {
      this.shadow = !((window.innerHeight + window.scrollY) >= document.body.offsetHeight)
    }
  },
  watch: {
    status (val) {
      if (val > 1) this.setChatPosition('75px', '43px')
    }
  },
  mounted () {
    this.setChatPosition('26px', '43px')
    this.handleShadow()
    window.addEventListener('scroll', this.handleShadow)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleShadow)
    this.setChatPosition()
  }
}
</script>
